<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  @if (addressId$ | async) {
  <form onsip-grid-placement-shelf [formGroup]="form">
    <section class="with-mat-form-field sip-address">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
      <onsip-sip-address-field formControlName="username"> </onsip-sip-address-field>
    </section>
    <section class="with-mat-form-field extensions">
      <div class="mat-body-1 property-header">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
      <onsip-extensions-list
        #extensionsList
        [currentId]="(addressId$ | async)!"
        formControlName="extensions"
      >
      </onsip-extensions-list>
    </section>
  </form>
  }
  <div class="page-view-controls">
    <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
    <button
      mat-flat-button
      type="submit"
      class="toggle-button"
      color="primary"
      (click)="submitForm()"
    >
      {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
    </button>
  </div>
</onsip-loading-container>
